import { render, staticRenderFns } from "./organization-list.view.vue?vue&type=template&id=40a7175a&"
import script from "./organization-list.view.vue?vue&type=script&lang=ts&"
export * from "./organization-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports